export default "__VITE_ASSET__CX07fY5g__"